/**
 * Runtime environment configuration helper
 * Reads from window.ENV which is populated by /env.js at runtime
 */

export function getEnv(key: string): string | undefined {
  return (window as any).ENV?.[key];
}

export function getAuthMode(): 'AUTH0' | 'API_KEY' {
  const mode = getEnv('AUTH_MODE')?.toUpperCase();
  return mode === 'API_KEY' ? 'API_KEY' : 'AUTH0';
}

export function getEnvironment(): 'staging' | 'production' {
  const env = getEnv('ENVIRONMENT')?.toLowerCase();
  return env === 'production' ? 'production' : 'staging';
}

export interface RuntimeEnv {
  ENVIRONMENT?: string;
  AUTH_MODE?: string;
  AUTH0_DOMAIN?: string;
  AUTH0_CLIENT_ID?: string;
  AUTH0_AUDIENCE?: string;
  AUTH0_SCOPE?: string;
  AUTH0_REDIRECT_URI?: string;
}

/**
 * Get all environment variables
 */
export function getAllEnv(): RuntimeEnv {
  return (window as any).ENV || {};
}
